export enum ETipoPessoa {
    Fisica = 1,
    Juridica = 2,
}
